
<div class="row row-style-card width-66pe" *ngIf="Showarrow">
  <a class="nav-link-hand new-button-counselling font-size-15px" title="Back To Counselling" (click)="BackToCounselling()"><i class="fas fa-angle-double-left font-size-16px margin-right-4px"></i>Back To Counselling</a>
</div>
<button (click)="topFunction()" id="myBtn" class="myBtn" title="Go to top">Top</button>
<!--<button (click)="Bottom()" class="myBtnBottom" title="Go to bottom">Bot</button>-->
<div class="card my-profile-form margin-top-20px" *ngIf="ShowCounselling">
  <div class="card-header wh-header card-title-schedule-bl padding-top-6px padding-bottom-6px">
    <div class="row margin-top-3px">
      <div class="col-md-3 padding-left-0px">
        Counselling  Register
      </div>
      <div class="col-md-8 padding-right-0px">
        <div class="col-md-3 float-right padding-left-0px padding-right-0px">
          <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
        </div>
        <div class="offset-md-7 col-md-2 text-align-right padding-right-0px padding-left-0px padding-right-0px">
          <a (click)="SearchPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
        </div>
      </div>
    </div>

  </div>
  <div class="card-body padding-top-0px">
    <!--<div class="row margin-bottom-10px margin-top-10">
      <div class="col-md-8 padding-left-30px padding-right-0px">
        <div class="row">
          <div class="col-md-3">
           
            <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
          </div>
         
        
        </div>
      </div>

    </div>
    <div class="row">
      <a (click)="SearchPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    </div>-->
    <div class="row">
      <div class="col-md-12">
        <div class="table-component">
          <div class="table-responsive overflow-x">


            <table class="table table-striped margin-left-zero"
                   cols="auto,2*,*,*,*,*,*,*">

              <thead class="">
                <tr>

                  <th class="td-width-103px">
                    Date
                  </th>
                  <!--<th class="text-align-center">Day</th>-->

                  <th class="">
                    Patient Name & Number
                  </th>
                  <th class="td-width-86px">Branch</th>
                  <th class="">Plan</th>
                  <!--<th class="td-width-159px">
                    Fin Status
                  </th>-->
                  <!--<th class="text-align-center">Start Time</th>-->
                  <th class="">
                    Plan Status
                  </th>





                  <th class=""></th>





                </tr>
              </thead>

              <tbody class="table-body">
                <tr *ngFor="let l of CurrentCounsellingPlanController">

                  <td class="padding-right-0px padding-top-0px padding-bottom-0px padding-left-10px">
                    <div [ngSwitch]="l.PlanStatus">
                      <div *ngSwitchCase="'Created'" class="td-border-8px-green">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Active'" class="td-border-8px-green">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Cancelled'" class="td-border-8px-red">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Completed'" class="td-border-8px-green">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Converted'" class="td-brorder-8px-blue">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'In Progress'" class="td-brorder-8px-blue">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Planned'" class="td-brorder-8px-blue">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="''" class="td-brorder-8px-blue">
                        <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                    </div>
                  </td>

                  <td class="padding-top-0px padding-bottom-0px padding-right-0px">
                    <div class="row">
                      <div class="col-md-5">
                        {{l.DisplayName}}
                      </div>
                      <div class="col-md-3 padding-left-0px padding-right-0px">
                        {{l.Telephone1}}
                      </div>
                    </div>
                      
                  </td>
                  <td class="padding-top-0px padding-bottom-0px">{{l.FacilityShortName}}</td>
                  <td class="padding-top-0px padding-bottom-0px">{{l.TreatmentPlan}}</td>
                  <!--<td class="td-padding-tb">{{l.FinancialStatus}}</td>-->

                  <td class="padding-top-0px padding-bottom-0px">{{l.PlanStatus}}</td>

                  <td class="padding-top-0px padding-bottom-0px">

                    <a class="nav-link-hand education-navlink" title="To Activies" (click)="Open(l)">
                      <span class="badge">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </a>
                    <a (click)="edit(l)" class="nav-link-hand education-navlink" title="Edit Plan">
                      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                    <a (click)="DeleteActivity(l)"
                       class="nav-link-hand font-size-14 color-Rejected" title="Remove">
                      <i class="far fa-trash-alt nav-link-hand"></i>
                    </a>
                    <!--<a (click)="del_(l.CounsellingPlanCode)" class="nav-link-hand education-navlink" title="Remove">
    <span class="badge">
   <i class="far fa-trash-alt"></i>
  </span>
    </a>-->
                    <!--<div *ngIf="">
    <button type="button" (click)="opendocuments()"
            class="btn  actions-btn-prime2 benfits-button font-size min-width-42px float-left margin-left-0px">
      <i class="fas fa-list"></i>
    </button>
  </div>-->
                    <div>
                      <!--<button type="button" (click)="AddPlan()"
            class="btn  btn-sm driver-button " title="Add">
      <i class="fas fa-plus font-size-11"></i>
    </button>-->
                    </div>
                  </td>

                </tr>

              </tbody>

            </table>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-align-center">
        <!--right align buttons-->
        
        <a>Records Loaded:
        <div class="badge badge-search padding-left-10px padding-right-10px padding-top-2px padding-bottom-2px ">
          <label style="color: white !important;"
                 class="margin-bottom-4px margin-top-4px data-color-white">
            {{LoadedRecordsCount}}
          </label>
        </div>
        </a>

        <button type="button"
                (click)="LoadCounselling()"
                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-left-15px margin-right-15px">
          First 50
        </button>

        <button type="button"
                (click)="LoadCounselling_Next()"
                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
          Next..
        </button>
      </div>
    </div>

  </div>
</div>

<activitymonitoring [FormattedCode]='Selectedpatient.FormattedCode' [ActorCode]='Selectedpatient.ActorCode' *ngIf="ShowMonitoring"></activitymonitoring>

<router-outlet></router-outlet>


<script>
//Get the button
var mybutton = document.getElementById("myBtn");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}


</script>
